import { useAtomValue, useSetAtom } from "jotai";
import { useTranslation } from "react-i18next";
import { resetSignUpData, signUpHistoryDepthAtom, setSignUpExiting } from "store/signUpStore";
import { userStore } from "store/userStore";

import './SignUpStep7.css'
import { Button } from "wiz-front-shared/components/button/Button";
import { AccountInfoBox, AccountInfoProvider } from "components/common/accountInfoBox/AccountInfoBox";

// Step7: 중복 로그인 (이미 가입된 계정)
// 로그인 페이지로 이동하는 버튼 제공
export const SignUpStep7 = () => {
    const { t } = useTranslation();
    const signupState = useAtomValue(userStore.signup.stateAtom);
    const checkDuplicateCtnState = useAtomValue(userStore.checkDuplicateCtn.stateAtom);
    const resetSignUp = useSetAtom(resetSignUpData);
    const historyDepth = useAtomValue(signUpHistoryDepthAtom);

    // ctn 중복 검사 응답에서 기존 회원 정보 추출
    const duplicateUser = checkDuplicateCtnState.data?.duplicateUsers?.[0];

    // API 에러 응답 또는 ctn 중복 검사 응답에서 기존 회원 정보 추출
    const signedUpType: AccountInfoProvider = duplicateUser?.provider || signupState.error?.provider || 'EMAIL';
    const signedUpDate: string = duplicateUser?.createDt || signupState.error?.createdAt || '';
    const maskedEmail: string = duplicateUser?.email || signupState.error?.maskedEmail || '';

    const handleGoToLogin = () => {
        // /signin 으로 빠져나가기 — flicker 없이 history pop. cascade 중 popstate handler 는 isExitingSignUp 으로 suppress.
        setSignUpExiting(true);
        window.history.go(-(historyDepth + 1));
        // atom 정리는 다음 tick (component 가 unmount 된 뒤에도 atom 은 살아있음 — 다음 진입 시 깨끗한 상태 위해)
        setTimeout(() => {
            userStore.signup.onDefault();
            userStore.checkDuplicateCtn.onDefault();
            resetSignUp();
        }, 0);
    };

    return (
        <div className="sign-up-step-7">
            <span className="title">{t("signUp.step7.title")}</span>
            <span className="info">{t("signUp.step7.info")}</span>

            <span style={{ marginTop: "50px", display: 'block', fontSize: "20px", fontWeight: 600 }}>{t("signUp.step7.alreadySignUpType", { type: t(signedUpType) })}</span>
            <AccountInfoBox provider={signedUpType} email={maskedEmail} signedUpDate={signedUpDate} />

            <div className="sign-up-bottom-btn">
                <Button
                    text={t("signInText")}
                    onPress={handleGoToLogin}
                />
            </div>
        </div>
    )
}
